import * as GC from '@grapecity/spread-sheets';

export function EllipsisCellType(maxWidth: number = 90) {
  maxWidth -= 5;

  function EllipsisTextCellType() {}
  EllipsisTextCellType.prototype = new GC.Spread.Sheets.CellTypes.Text();
  const ellipsisCustomPaint = function (ctx, value, x, y, w, h, style, context) {
    if (!ctx) {
      return;
    }
    // It intercepts the value and applies the ellipsis at the end
    value = fittingString(ctx, value, maxWidth);
    return new GC.Spread.Sheets.CellTypes.Text().paint(ctx, value, x, y, w, h, style, context);
  };
  EllipsisTextCellType.prototype.paint = ellipsisCustomPaint;

  return new EllipsisTextCellType();
}

export function fittingString(c, str: string, maxWidth) {
  const ellipsis = '…';
  let strWidth = c.measureText(str).width;
  const ellipsisWidth = c.measureText(ellipsis).width;

  if (strWidth <= maxWidth || strWidth <= ellipsisWidth) {
    return str;
  } else {
    let len = str.length;
    while (strWidth >= maxWidth - ellipsisWidth && len-- > 0) {
      str = str.substring(0, len);
      strWidth = c.measureText(str).width;
    }
    const finalStr = `${str}${ellipsis}`;
    return finalStr;
  }
}
